/* Created By CoolGuy on 2017/11/12
 */

import React from 'react';
import './Head.scss';
import { isWeb } from '../../utils/util';
import imageUtil from '../../utils/image.js';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay, virtualize } from 'react-swipeable-views-utils';
import Pagination from '../Pagination/Pagination';
import StatisticsRow from '../StatisticsRow';
import { IComponentSlideHead } from '../../component.d';
import SimpleBigPic from '../BigPic/SimpleBigPic';
import ComponentLink from '../ComponentLink/index';

const VirtualizeSwipeableViews = virtualize((SwipeableViews)) as any;
// todo: 写不来，先这样了
const AutoPlaySwipeableViews = autoPlay(VirtualizeSwipeableViews) as any;

export interface IOneHeadImg {
  image?: string;
  url: string;
  index: number;
}

interface IHead {
  imageviews?: number;
  imagecount?: number;
}

class Head extends React.Component<IComponentSlideHead & IHead, any> {
  state = {
    index: 0,
    bigIndex: -1,
    images: [],
    paintVersion: 0
  };

  repaintAfterSearchResultClose = () => {
    // The search result is a fixed scroll layer. On newer iOS WebViews, removing
    // it can invalidate the backing store of the transformed SwipeableViews
    // beneath it while leaving the img DOM and load state untouched. Remounting
    // just the swipe layer restores painting without resetting page scroll or
    // downloading gallery data again.
    this.setState((state: any) => ({
      paintVersion: state.paintVersion + 1
    }));
  };

  handleChangeIndex = (index: number) => {
    // console.log(index, 'handle change index');
    this.setState({
      index
    });
  };
  // 因为相片页上一般都有一个头图，而头图的高度是不确定的，所以等至少一张头图的高度加载出来了，高度就定下来了
  // 此时丢一个事件出来，方便其他地方（主要是相片列表）接收到这个事件后做处理
  // 注意，不一定 有这个事件，所以请不要过度依赖这个事件。
  onePicLoaded = () => {
    // console.log('one head pic loaded');
    window.dispatchEvent(new Event('head-pic-loaded'));
  };

  eventControl = (event: any) => {
    const { duration, slides } = this.props;
    if (event) {
      let { data } = event;

      if (data == 'prep') {
        this.setState({
          index: Math.max(0, this.state.index - 1)
        });
      }
      if (data == 'next') {
        this.setState({
          index: Math.min(this.state.index + 1, slides.length - 1)
        });
      }
    }
  };

  componentDidMount() {
    let { cid, slides } = this.props;

    let images = (slides || []).map((it: any, index) => {
      return {
        it: index + 1,
        hash: it.image
      };
    });

    this.setState({
      images
    });

    window.addEventListener('slider-control-' + cid, this.eventControl);
    window.addEventListener(
      'search-result-overlay-closed',
      this.repaintAfterSearchResultClose
    );
  }

  componentWillUnmount() {
    let { cid } = this.props;
    window.removeEventListener('slider-control-' + cid, this.eventControl);
    window.removeEventListener(
      'search-result-overlay-closed',
      this.repaintAfterSearchResultClose
    );
  }

  getCurrentIndexClass = (index: number) => {
    let between = this.state.index - index;

    let cls = [];
    if (Number(between) != 0) {
      cls.push('smaller');
      if (between < 0) {
        cls.push('right');
      }
      if (between > 0) {
        cls.push('left');
      }
    }

    return cls.join(' ');
  };

  loadBigPic = () => {
    this.setState({
      images: this.state.images.map((it: any, index: number) => {
        if (index == this.state.bigIndex) {
          it.loadStatus = 'loading';
        }
        return it;
      })
    });
  }

  loadFinish = (ind: number) => {
    this.setState({
      images: this.state.images.map((it: any, index: number) => {
        if (index == ind) {
          it.loadStatus = 'loaded';
        }
        return it;
      })
    });
  }

  renderMain = () => {
    const { duration, slides, pinch, mode = 'template1' } = this.props;
    let { bigIndex, paintVersion } = this.state;
    // 正常的图片或者轮播
    // 这里用MAX_SAFE_INTEGER 会出现不停循环的问题，所以设定一个非常大的值即可
    // duration单位是毫秒
    const interval = slides.length > 1 ? duration || 5000 : 3600 * 1000;

    // const images = (slides || []).map((it: any, index) => {
    //   return {
    //     it: index + 1,
    //     hash: it.image
    //   };
    // });
    let images = this.state.images;

    const styles = {
      root: {
        padding: '0 20px',
        overflow: 'hidden'
      },
      slideContainer: {
        padding: '0 5px',
        width: 'calc(100% - 10px)',
        overflow: 'visible'
      },
      slide: {
        minHeight: 100,
        height: 'auto',
        width: '100%',
        borderRadius: '8px'
      }
    };
    // console.log(interval, 'head interval');

    const slideRenderer = (params: any) => {
      const { index, key } = params;

      const mod = Math.abs(index % slides.length);
      const one = slides[mod];
      const cls = `one-head-img ${this.getCurrentIndexClass(index)}`;
      return (
        <img
          onClick={() => {
            let linkValue = one.link && one.link.type;
            if (linkValue && linkValue != 'empty') {
              ComponentLink.to(one.link);
            } else if (pinch) {
              this.setBigIndex(mod);
            }
          }}
          onLoad={this.onePicLoaded}
          key={key}
          src={imageUtil.style(
            one.image,
            mode == 'template1' ? 'wx_750_n' : 'wx_750_n',
            { webp: false },
            1
          )}
          alt=""
          className={cls}
          style={Object.assign(
            { width: '100%' },
            mode == 'template1' ? {} : styles.slide
          )}
        />
      )
    };

    return slides && slides.length ? (
      <div style={{ lineHeight: 0 }}>
        {slides && slides.length > 1 ? <AutoPlaySwipeableViews
          key={`head-swipe-${paintVersion}`}
          axis="x"
          enableMouseEvents={true}
          index={this.state.index}
          onChangeIndex={this.handleChangeIndex}
          slideStyle={
            mode == 'template1' ? { overflow: 'hidden' } : styles.slideContainer
          }
          style={mode == 'template1' ? {} : styles.root}
          interval={interval}
          slideRenderer={slideRenderer}
        /> : <SwipeableViews
          key={`head-swipe-${paintVersion}`}
          axis="x"
          enableMouseEvents={true}
          index={this.state.index}
          onChangeIndex={this.handleChangeIndex}
          slideStyle={
            mode == 'template1' ? { overflow: 'hidden' } : styles.slideContainer
          }
          style={mode == 'template1' ? {} : styles.root}
        >
          {slideRenderer({ index: 0, key: 0 })}
        </SwipeableViews>}
        {slides.length > 1 && (
          <Pagination
            dots={slides.length}
            index={Math.abs(this.state.index % slides.length)}
            onChangeIndex={this.handleChangeIndex}
            mode={mode}
          />
        )}

        {pinch ? (
          <SimpleBigPic
            pageType="SliderHead"
            index={bigIndex}
            list={images}
            setIndex={this.setBigIndex}
            loadBigPic={this.loadBigPic}
            loadFinish={this.loadFinish}
          />
        ) : null}
      </div>
    ) : null;
  };

  setBigIndex = (index: number) => {
    this.setState({
      bigIndex: Number(index)
    });
  };

  render() {
    const { props } = this;
    let { imagecount, imageviews, total } = props;
    return (
      <div style={{ position: 'relative', minHeight: 45 }}>
        {!!total && !!imagecount ? (
          <div className="head-bottom">
            <StatisticsRow
              n1={imagecount || 0}
              n2={imageviews || 0}
              fontColor={'#fff'}
            />
          </div>
        ) : null}
        {this.renderMain()}
      </div>
    );
  }
}

export default Head;
